import React, { useState, useEffect } from "react";

import { useFormikContext } from "formik";
import { isEmpty, isNil } from "ramda";

import { Button, Typography } from "clearsense-ui/components";
import { Input, Select } from "clearsense-ui/components/formik";
import { Edit, Delete } from "components/Common/clearsense-ui/icons";

import { FIELD_TYPE } from "../constants";

const ViewField = ({ name, type, setFieldValue, index, hierarchyIndex }) => (
  <div className="flex justify-between items-center p-3 border rounded-sm border-content-300 w-full mt-2 bg-grey-blue">
    <div>
      <Typography
        type="semibold"
        className="text-content-darker dark:text-white leading-4"
      >
        Field {`${name}`}
      </Typography>
      <Typography className=" leading-4 text-content-800">
        type: {`${type.label}`}
      </Typography>
    </div>
    <Button
      icon={Edit}
      style="text"
      iconSize="24"
      onClick={() =>
        setFieldValue(
          `hierarchies.${hierarchyIndex}.fields.${index}.isEdit`,
          true
        )
      }
    />
  </div>
);

const TemplateField = ({
  field,
  index,
  arrayHelpers,
  hierarchy,
  hierarchyIndex,
}) => {
  const [previousData, setPreviousData] = useState();
  const { errors, setFieldValue, setFieldTouched, getFieldMeta } =
    useFormikContext();

  useEffect(() => {
    if (!field?.isEdit) {
      setPreviousData(field);
    }
  }, [field]);

  const handleFieldSave = () => {
    const fieldErrors = errors?.hierarchies?.[hierarchyIndex]?.fields?.[index];
    const isNameTouched = getFieldMeta(
      `hierarchies.${hierarchyIndex}.fields.${index}.name`
    ).touched;
    const isTypeTouched = getFieldMeta(
      `hierarchies.${hierarchyIndex}.fields.${index}.type`
    ).touched;
    const hasNoError =
      isNil(fieldErrors) || isEmpty(fieldErrors) || fieldErrors?.length === 0;
    setFieldTouched(`hierarchies.${hierarchyIndex}.fields.${index}.name`, true);
    setFieldTouched(`hierarchies.${hierarchyIndex}.fields.${index}.type`, true);

    if (hasNoError && isNameTouched && isTypeTouched) {
      setFieldValue(
        `hierarchies.${hierarchyIndex}.fields.${index}.isEdit`,
        false
      );
      setFieldValue(
        `hierarchies.${hierarchyIndex}.fields.${index}.isInitial`,
        false
      );
    }
  };

  const handleSaveCancel = () => {
    if (field.isInitial) {
      arrayHelpers.remove(index);
    } else {
      setFieldValue(
        `hierarchies.${hierarchyIndex}.fields.${index}.isEdit`,
        false
      );
      setFieldValue(
        `hierarchies.${hierarchyIndex}.fields.${index}.name`,
        previousData.name
      );
      setFieldValue(
        `hierarchies.${hierarchyIndex}.fields.${index}.type`,
        previousData.type
      );
    }
  };

  if (!field?.isEdit) {
    return (
      <ViewField
        name={field.name ?? "NO name"}
        type={field.type ?? "No type"}
        setFieldValue={setFieldValue}
        index={index}
        hierarchyIndex={hierarchyIndex}
      />
    );
  }

  return (
    <div className=" p-3 border border-shade-light w-full mt-4">
      <Typography
        style="condensedMedium"
        className="text-content-darker dark:text-white mb-4"
      >
        Add a Field
      </Typography>
      <Input
        name={`hierarchies.${hierarchyIndex}.fields.${index}.name`}
        label="Field Name"
        placeholder="Enter Name"
        required
      />
      <Select
        name={`hierarchies.${hierarchyIndex}.fields.${index}.type`}
        options={FIELD_TYPE}
        label="Field Type"
        placeholder="Select Type"
        className="mt-4"
        required
      />
      <div className=" flex gap-2 mt-4">
        <Button label="Save field" onClick={handleFieldSave} />
        <Button
          label="Cancel"
          style="secondary"
          disabled={hierarchy.fields.length <= 1}
          onClick={handleSaveCancel}
        />
        {!field.isInitial && (
          <Button
            icon={Delete}
            style="secondary"
            className="text-red-700"
            onClick={() => arrayHelpers.remove(index)}
            disabled={hierarchy.fields.length <= 1}
          />
        )}
      </div>
    </div>
  );
};

export default TemplateField;
